import React, { PureComponent } from 'react'
import { Modal, Col, Row, FormGroup, Button } from 'react-bootstrap'
import InputText from '../../../components/commons/form/InputText'
import InputDatePicker from '../../../components/commons/form/InputDatePicker'
import InputSelect from '../../../components/commons/form/InputSelect'
import settings from '../../../setting'
import { clientInformation } from '../../../constants/backendIds'
import { handleKeyDown } from '../../../util/utils'
import { reduxForm, Field } from 'redux-form'

class IssueModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps) {
    if (this.props.showModal !== prevProps.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.service.dossierServiceComponent)
      this.props.actions.fetchIssueEntity()
    }
  }

  submitService (values) {
    if (values) {
      if (this.props.service.dossierServiceComponent &&
        values.availabilityDate !== this.props.service.dossierServiceComponent?.availabilityDate &&
        settings.clientFieldValidation === clientInformation.VGR) {
        values.requiredDate = null
      }
      const body = {
        ...values
      }
      this.props.actions.saveIssueService(body)
    }
  }

  render () {
    const { handleSubmit, showModal, actions: { openOrCloseModal }, combos: { issuesEntities }, t } = this.props
    const tKey = 'DOSSIER_COMPONENTS.SERVICE_DOSSIER.SERVICE_COMPONENT.ISSUE_MODAL.'
    return (
      <Modal id='IssueModal' className="_nf" show={showModal} onHide={openOrCloseModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitService.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={openOrCloseModal}>
            <Modal.Title> {t(`${tKey}TITLE`)} </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <Row className="fieldsContainer">
                {settings.clientFieldValidation === clientInformation.VGR ? (
                  <>
                    <Field
                      component={InputDatePicker}
                      colWidth={33} // 25, 33, 50, 75, 100 default=25
                      id="availabilityDate"
                      name="availabilityDate"
                      controlLabel={t(`${tKey}AVAILABILITY_DATE`)}
                      placeholder={t(`${tKey}AVAILABILITY_DATE`)}
                    />
                  </>
                ) : (
                  <Field
                    component={InputDatePicker}
                    colWidth={50} // 25, 33, 50, 75, 100 default=25
                    controlLabel={t(`${tKey}CONFIRMED_DATE`)}
                    id="confirmedDate"
                    name="confirmedDate"
                    placeholder={t(`${tKey}CONFIRMED_DATE`)}
                  />)
                }

                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="issueEntityId"
                  controlLabel={t(`${tKey}RESPONSABLE`)}
                  placeholder={t(`${tKey}RESPONSABLE`)}
                  valueKey="id"
                  labelKey="value"
                  options={issuesEntities}
                />

                <Field
                  component={InputText}
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  id="providerObservations"
                  name="providerObservations"
                  controlLabel={t(`${tKey}PROVIDER_OBSERVATIONS`)}
                  placeholder={t(`${tKey}PROVIDER_OBSERVATIONS`)}
                  customClass="textarea-noresize"
                  componentClass="textarea"
                />

              </Row>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Col className="flexInLine al-C">
              <Button
                id="role-modal-submit-button"
                className="_Btn accept"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SAVE`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'issueServiceModal',
  validate: (values, props) => {
    const error = { agency: {} }
    const tKey = 'DOSSIER_COMPONENTS.SERVICE_DOSSIER.SERVICE_COMPONENT.ISSUE_MODAL.VALIDATIONS.'
    if (!values.confirmedDate) {
      error.confirmedDate = props.t(`${tKey}CONFIRMED_DATE`)
    }
    if (!values.providerObservations) {
      error.providerObservations = props.t(`${tKey}PROVIDER_OBSERVATIONS`)
    }
    if (!values.issueEntityId) {
      error.issueEntityId = props.t(`${tKey}RESPONSABLE`)
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(IssueModal)
